<template>
  <section v-if="componentReady" class="container-wrapper model-page">
    <div class="container">
      <h1>{{ title }}</h1>
      <VinChecker />

      <div class="model-page__models">
        <Cars
          :cars="models"
          @select="onModelSelected"
        />
      </div>
      <div class="model-page__no" />
    </div>
  </section>
</template>

<script>
  // Step 1

  import { get } from 'lodash'
  import { mapActions } from 'vuex'
  import VinChecker from '@/components/VinChecker'
  import Cars from '@/components/Cars/Cars'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'ModelPage',

    components: {
      VinChecker,
      Cars
    },

    data () {
      return {
        title: '',
        models: [],
        componentReady: false,
        firstTime: true
      }
    },
    async created () {
      const data = await this.fetchModelPageData()
      this._data = Object.assign(this._data, data)

      this.componentReady = true

      this.loadDataLayer()
    },

    activated () {
      if (!this.firstTime) {
        location.reload()
      }
      this.firstTime = false
    },

    methods: {
      ...mapActions(['fetchModelPageData']),
      onModelSelected (model) {
        this.modelText = this.checkNull(get(this.models.find(item => item.value === model), 'label', ''))
        this.modelId = this.checkNull(get(this.models.find(item => item.value === model), 'toyotaModelId', ''))
        this.$store.commit('SET_MODEL', {
          modelText: this.modelText,
          modelId: this.modelId
        })

        let query = {}
        if (this.$store.state.currentLang !== DEFAULT_LANG) {
          query = { lang: this.$store.state.currentLang }
        }

        this.$router.push({
          name: 'year',
          params: { model },
          query
        })
      },

      checkNull (data) {
        if (data) return data
        return ''
      },
      loadDataLayer () {
        this.pushDataToDataLayer({
          page: {
            category: 'tools',
            subCategory: 'maintenance',
            sectionlv1: 'tool',
            sectionlv2: 'maintenance-calculator',
            language: this.$store.state.currentLang
          },
          workflow: {
            name: 'maintenance-calculator',
            step: 'select-model',
            conversion: '0'
          }
        })
      },
      pushDataToDataLayer (params = {} || window.tngaDataLayer, pushDataLayer = false) {
        window.dataLayer = window.dataLayer || []
        window.tngaDataLayer = { ...params }

        if (pushDataLayer) window.dataLayer.push({ 'event': 'workflowevent' })
      }
    }
  }
</script>

<style lang="scss">
  .model-page {
    &__models {
      margin-top: 75px;

      @include mobile {
        margin-top: 35px;
      }
    }

    &__no {
      display: none;
    }
  }
</style>
